import React from 'react';

import styles from './ReviewsPage.module.css';

type TProps = {
  children: React.ReactNode;
};

export const ReviewsPageWrapper = ({ children }: TProps) => (
  <div className={styles.ReviewsPage__Wrapper}>{children}</div>
);
